// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../__generated__/schema.graphql.types";
import { ClientInterestInPaymentPlansFragmentDoc } from "../fragments/paymentPlans/clientInterestInPaymentPlans.graphql.types";
import { TelehealthIconFieldsFragmentDoc } from "../fragments/telehealth/telehealthFields.graphql.types";

const defaultOptions = {} as const;
export type ClientByTokenQueryVariables = Types.Exact<{
  token: Types.Scalars["String"]["input"];
}>;

export type ClientByTokenQuery = {
  __typename?: "query_root";
  clientAccessTokenByPk?: {
    __typename?: "clientAccessToken";
    client: {
      __typename?: "client";
      id: string;
      firstName: string;
      lastName: string;
      interestedInPaymentPlans?: boolean | null;
      consentFormSignatures: Array<{
        __typename?: "consentFormSignature";
        id: string;
        created: string;
        signature?: string | null;
        signedAt?: string | null;
        signedConsentFormText: string;
        isOptOut?: boolean | null;
        client: { __typename?: "client"; id: string; fullName?: string | null };
        consentForm: {
          __typename?: "consentForm";
          id: string;
          name: string;
          allowOptOut: boolean;
          text: string;
          serviceMenuItems: Array<{
            __typename?: "consentFormServiceMenuItems";
            serviceMenuItem: {
              __typename?: "MedspaServiceMenuItem";
              id: string;
              name: string;
            };
          }>;
        };
        visit?: { __typename?: "visit"; id: string; status: string } | null;
      }>;
      medspa: {
        __typename?: "medspa";
        id: string;
        name: string;
        contactEmail: string;
        contactPhone: string;
        address?: {
          __typename?: "address";
          addressLine1: string;
          addressLine2: string;
          city: string;
          zipCode: string;
          state: string;
        } | null;
        additionalPublicInfo?: {
          __typename?: "MedspaPublicInfoType";
          id: string;
          logo?: string | null;
          enabledFeatures: Array<string | null>;
        } | null;
        configuration?: {
          __typename?: "MedspasMedspaconfiguration";
          customizationEnabled: boolean;
          cherryApplicationLink: string;
          cherryPromotionEnabled: boolean;
          affirmPromotionEnabled: boolean;
        } | null;
      };
      visits: Array<{
        __typename?: "visit";
        id: string;
        startTime: string;
        status: string;
        isVisitTelehealth?: boolean | null;
        appointment?: {
          __typename?: "SchedulingAppointment";
          id: string;
          startTime?: string | null;
          endTime?: string | null;
          accessToken: string;
        } | null;
        provider: {
          __typename?: "user";
          id: string;
          firstName: string;
          lastName: string;
        };
        medspa: {
          __typename?: "medspa";
          id: string;
          slug: string;
          name: string;
        };
        serviceMenuItemLines: Array<{
          __typename?: "ServiceMenuItemLine";
          id: string;
          serviceMenuItem: {
            __typename?: "MedspaServiceMenuItem";
            name: string;
            id: string;
            medspaServiceOfferings: Array<{
              __typename?: "MedspaServiceMenuItemMedspaServiceOfferings";
              id: string;
              medspaserviceofferingId: string;
            }>;
            careFormServiceMenuItems: Array<{
              __typename?: "careFormServiceMenuItems";
              careform: {
                __typename?: "careForm";
                text: string;
                name: string;
                id: string;
                formType: string;
              };
            }>;
          };
        }>;
        telehealthVisitDetails?: {
          __typename?: "TelehealthVisitDetails";
          visitType: string;
          videoLink?: string | null;
        } | null;
      }>;
      formSubmissions: Array<{
        __typename?: "formSubmission";
        id: string;
        externalSubmissionId: string;
        submittedAt?: string | null;
        content: JSONb;
        gfeStatus: string;
        expiresAt?: string | null;
        client: { __typename?: "client"; id: string; fullName?: string | null };
        form: {
          __typename?: "form";
          id: string;
          jotformId: string;
          title: string;
          schema: JSONb;
          uiSchema: JSONb;
          allServices: boolean;
          archivedAt?: string | null;
          medspaServiceOfferings: Array<{
            __typename?: "FormsFormMedspaServiceOfferings";
            id: string;
            medspaserviceofferingId: string;
          }>;
        };
        medspa: { __typename?: "medspa"; id: string; name: string };
        versions: Array<{
          __typename?: "FormsFormsubmissionversion";
          id: string;
          version: number;
          created: string;
          schema: JSONb;
          uiSchema: JSONb;
          signedAt?: string | null;
          submittedData: JSONb;
          consentToTerms: boolean;
          consentToMarketing: boolean;
        }>;
      }>;
    };
  } | null;
};

export const ClientByTokenDocument = gql`
  query ClientByToken($token: String!) {
    clientAccessTokenByPk(token: $token) {
      client {
        id
        firstName
        lastName
        ...ClientInterestInPaymentPlans
        consentFormSignatures(
          where: {
            consentForm: { deletedAt: { _isNull: true } }
            expiredAt: { _isNull: true }
          }
        ) {
          id
          created
          client {
            id
            fullName
          }
          consentForm {
            id
            name
            allowOptOut
            text
            serviceMenuItems {
              serviceMenuItem {
                id
                name
              }
            }
          }
          signature
          signedAt
          signedConsentFormText
          isOptOut
          visit {
            id
            status
          }
        }
        medspa {
          id
          name
          address {
            addressLine1
            addressLine2
            city
            zipCode
            state
          }
          contactEmail
          contactPhone
          additionalPublicInfo {
            id
            logo
            enabledFeatures
          }
          configuration {
            customizationEnabled
            cherryApplicationLink
            cherryPromotionEnabled
            affirmPromotionEnabled
          }
        }
        visits(orderBy: { appointment: { startTime: DESC } }) {
          id
          startTime
          status
          ...TelehealthIconFields
          appointment {
            id
            startTime
            endTime
            accessToken
          }
          provider {
            id
            firstName
            lastName
          }
          medspa {
            id
            slug
            name
          }
          serviceMenuItemLines {
            id
            serviceMenuItem {
              medspaServiceOfferings(
                where: { serviceOffering: { isEnabled: { _eq: true } } }
              ) {
                id
                medspaserviceofferingId
              }
              careFormServiceMenuItems(
                where: { careform: { deleted: { _eq: false } } }
              ) {
                careform {
                  text
                  name
                  id
                  formType
                }
              }
              name
              id
            }
          }
        }
        formSubmissions {
          id
          externalSubmissionId
          submittedAt
          content
          gfeStatus
          expiresAt
          client {
            id
            fullName
          }
          form {
            id
            jotformId
            title
            schema
            uiSchema
            allServices
            archivedAt
            medspaServiceOfferings(
              where: { medspaServiceOffering: { isEnabled: { _eq: true } } }
            ) {
              id
              medspaserviceofferingId
            }
          }
          medspa {
            id
            name
          }
          versions(orderBy: { version: DESC }) {
            id
            version
            created
            schema
            uiSchema
            signedAt
            submittedData
            consentToTerms
            consentToMarketing
          }
        }
      }
    }
  }
  ${ClientInterestInPaymentPlansFragmentDoc}
  ${TelehealthIconFieldsFragmentDoc}
`;

/**
 * __useClientByTokenQuery__
 *
 * To run a query within a React component, call `useClientByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useClientByTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientByTokenQuery,
    ClientByTokenQueryVariables
  > &
    (
      | { variables: ClientByTokenQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientByTokenQuery, ClientByTokenQueryVariables>(
    ClientByTokenDocument,
    options
  );
}
export function useClientByTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientByTokenQuery,
    ClientByTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClientByTokenQuery, ClientByTokenQueryVariables>(
    ClientByTokenDocument,
    options
  );
}
export function useClientByTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClientByTokenQuery,
        ClientByTokenQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClientByTokenQuery,
    ClientByTokenQueryVariables
  >(ClientByTokenDocument, options);
}
export type ClientByTokenQueryHookResult = ReturnType<
  typeof useClientByTokenQuery
>;
export type ClientByTokenLazyQueryHookResult = ReturnType<
  typeof useClientByTokenLazyQuery
>;
export type ClientByTokenSuspenseQueryHookResult = ReturnType<
  typeof useClientByTokenSuspenseQuery
>;
export type ClientByTokenQueryResult = Apollo.QueryResult<
  ClientByTokenQuery,
  ClientByTokenQueryVariables
>;
